import Swiper, { Autoplay, Navigation, Scrollbar } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let snapshotSwiperWr = document.querySelectorAll('.snapshot-swiper-wr');

snapshotSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let parentEl = el.parentElement;
    let nextEl = parentEl.querySelector('.swiper-button-next');
    let prevEl = parentEl.querySelector('.swiper-button-prev');
    let scrollbarEl = parentEl.querySelector('.snapshot-sec__scrollbar');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Scrollbar],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 14,
      slidesPerView: 1,
      threshold: 10,
      initialSlide: slidesCount > 3 && window.innerWidth >= 641 ? 1 : 0,
      // loop: true,
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        641: {
          slidesPerView: 2,
          spaceBetween: 14,
        },
        768: {
          spaceBetween: 16,
          slidesPerView: 2,
        },
        1024: {
          spaceBetween: 18,
          slidesPerView: 2,
        },
        1280: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1024,
      },
    });
    swiperObserver(swiper);
  }
});